import { Serializable } from '../../../../../../_shared/model/deserialize.service';
import { Reservation } from './../../../../../../_shared/model/reservation.model';
export class KbItem implements Serializable<KbItem> {
    status: string;
    isPriority?: boolean;
    data: Reservation;

    deserialize(input) {
        this.status = input.status;
        this.data = input.data;
        this.isPriority = input.isPriority;

        return this;
    }
}
